import type { RouteObject } from 'react-router';
import { page } from '@/lib/lazy-route';

// Phase H (H-E pensions): Settings -> Payroll -> Pensions, mounted by the admin layout. The pay-run
// screens (Track H-F) own modules/payroll/routes.tsx; this file only adds the settings page.
export const settingsRoutes: RouteObject[] = [{ path: 'payroll-pensions', lazy: page(() => import('./settings-page'), (m) => m.PensionSettingsPage) }];
